const SERVICE_DOMAIN = process.env.REACT_APP_MICROCMS_SERVICE_DOMAIN;
const API_KEY = process.env.REACT_APP_MICROCMS_API_KEY;

export async function getPage(slug) {
  const res = await fetch(
    `https://${SERVICE_DOMAIN}.microcms.io/api/v1/pages?filters=slug[equals]${encodeURIComponent(slug)}`,
    { headers: { 'X-MICROCMS-API-KEY': API_KEY } }
  );
  if (!res.ok) throw new Error(`microCMS error: ${res.status}`);
  const data = await res.json();
  return data.contents[0] || null;
}

export async function getPages() {
  const res = await fetch(
    `https://${SERVICE_DOMAIN}.microcms.io/api/v1/pages?fields=title,slug`,
    { headers: { 'X-MICROCMS-API-KEY': API_KEY } }
  );
  if (!res.ok) throw new Error(`microCMS error: ${res.status}`);
  const data = await res.json();
  return data.contents;
}

export async function getBlogPosts(limit = 20, offset = 0) {
  const res = await fetch(
    `https://${SERVICE_DOMAIN}.microcms.io/api/v1/blog?limit=${limit}&offset=${offset}&orders=-publishedAt&fields=id,title,slug,description,category,eyecatch,publishedAt`,
    { headers: { 'X-MICROCMS-API-KEY': API_KEY } }
  );
  if (!res.ok) throw new Error(`microCMS error: ${res.status}`);
  const data = await res.json();
  return data;
}

export async function getBlogPost(slug) {
  const res = await fetch(
    `https://${SERVICE_DOMAIN}.microcms.io/api/v1/blog?filters=slug[equals]${encodeURIComponent(slug)}`,
    { headers: { 'X-MICROCMS-API-KEY': API_KEY } }
  );
  if (!res.ok) throw new Error(`microCMS error: ${res.status}`);
  const data = await res.json();
  return data.contents[0] || null;
}
